import { apiTags } from "app/store/apiTags";
import { baseQuery } from "../../app/baseQuery";
import { baseApi } from 'app/baseApi';

const baseUrl = 'carrier';

export const carrierApi = baseApi.injectEndpoints({
    reducerPath: 'carrierApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getAllCarriers: builder.query({
            query: (carrierId) => `${baseUrl}/full?${carrierId ? `carrierId=${carrierId}` : ''}`,
            providesTags: [apiTags.ACCESS, apiTags.CARRIER],
            transformResponse: (response) => {
                return response?.map(Carrier => ({
                    ...Carrier,
                    pocName: Carrier?.pocInfo?.[0]?.name,
                    pocEmail: Carrier?.pocInfo?.[0]?.email,
                    pocPhone: Carrier?.pocInfo?.[0]?.phone,
                    address: Carrier?.pocInfo?.[0]?.address,
                    city: Carrier?.pocInfo?.[0]?.city,
                    state: Carrier?.pocInfo?.[0]?.state,
                    zipcode: Carrier?.pocInfo?.[0]?.zipCode,
                    secPocName: Carrier?.pocInfo?.[1]?.name,
                    secPocEmail: Carrier?.pocInfo?.[1]?.email,
                    secPocPhone: Carrier?.pocInfo?.[1]?.phone,
                    secAddress: Carrier?.pocInfo?.[1]?.address,
                    secCity: Carrier?.pocInfo?.[1]?.city,
                    secState: Carrier?.pocInfo?.[1]?.state,
                    secZipcode: Carrier?.pocInfo?.[1]?.zipCode,
                })) ?? []
            }

        }),
        createCarrier: builder.mutation({
            query: carrier => ({
                url: `${baseUrl}`,
                method: 'POST',
                body: carrier
            }),
            invalidatesTags: [apiTags.CARRIER]
        }),
        updateCarrier: builder.mutation({
            query: carrier => ({
                url: `${baseUrl}`,
                method: 'PUT',
                body: carrier
            }),
            invalidatesTags: [apiTags.CARRIER, apiTags.RESERVATION]
        })
    }),
});

export const { useGetAllCarriersQuery,
    useCreateCarrierMutation,
    useUpdateCarrierMutation
} = carrierApi;
